import { APICallV3Post } from 'reactApp/api/APICall';

export class NotifyApplinkAPICall extends APICallV3Post {
    _method = 'notify/applink';
}
